import {
  FILES_PAGE,
  GENERAL_SETTINGS_PAGE,
  SETTINGS_PAGE_ROOT_PATH,
} from 'src/constants';

const matchesPath = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

export const isFilesNavItemSelected = (pathname: string) =>
  matchesPath(pathname, FILES_PAGE.path);

export const isGeneralSettingsNavItemSelected = (pathname: string) =>
  pathname === SETTINGS_PAGE_ROOT_PATH ||
  matchesPath(pathname, GENERAL_SETTINGS_PAGE.path);
